import OnboardingFooter from '../../components/OnboardingFooter';
import OnboardingView from '../../views/OnboardingView';

export default function Onboarding() {
  return (
    <main className="relative z-10 flex flex-1 flex-col items-center justify-between gap-10 pb-5">
      <OnboardingView />
      <OnboardingFooter />
    </main>
  );
}
